// extracted by mini-css-extract-plugin
export default {"list":"About_list__y3gq+","title":"About_title__Tz4EP"};